"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CertificatesListStats = void 0;

var tslib_1 = require("tslib");

var common_1 = require("./common");

var shared_1 = require("../shared");

var dayjs_1 = tslib_1.__importDefault(require("dayjs"));

var CertificatesListStats =
/** @class */
function () {
  function CertificatesListStats(options) {
    var _this = this;

    this.options = options;
    this.hr = '---------------------------------------------------------------------------------';
    this.br = '\n';
    this.tab = '  ';
    this.text = [];
    this.tabLevel = 0;

    this.print = function () {
      _this.printPluginInfo();

      _this.printCertificatesInfo();
    };

    this.addLine = function (line) {
      if (_this.tabLevel > 0) {
        var tabs = '';
        var tabCount = _this.tabLevel;

        while (tabCount > 0) {
          tabs += "" + _this.tab;
          tabCount--;
        }

        line = "" + tabs + line;
      }

      _this.text.push(line);
    };

    this.addHr = function () {
      return _this.addLine(_this.hr);
    };

    this.formatDayStr = function (n) {
      return n + " " + common_1.getPluralForm(n, ['день', 'дня', 'дней']);
    };

    this.printError = function (error) {
      _this.addLine("\u041E\u0448\u0438\u0431\u043A\u0430. " + error.code + ":" + error.message);

      _this.printCurrentText();
    };

    this.printCurrentText = function () {
      _this.text.push(_this.hr);

      console.log(_this.text.join(_this.br));
      _this.text = [];
    };

    this.printPluginInfo = function () {
      // Выводим информацию о Плагине.
      var _a = _this.options,
          pluginSetupResult = _a.pluginSetupResult,
          error = _a.error;

      _this.addHr();

      if (pluginSetupResult) {
        var pluginInfo = pluginSetupResult.pluginInfo;
        var pluginName = common_1.compareVersions(pluginInfo.version, '3') >= 0 ? 'Контур.Плагин' : 'Контур.Тулбокс';

        _this.addLine("\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u043C\u044B\u0439 \u043F\u043B\u0430\u0433\u0438\u043D: " + pluginName);

        _this.addLine("\u0412\u0435\u0440\u0441\u0438\u044F \u043F\u043B\u0430\u0433\u0438\u043D\u0430: " + pluginInfo.version);

        _this.printCurrentText();
      } else {
        _this.printError(error);
      }
    };

    this.printCertificatesInfo = function () {
      var _a = _this.options,
          error = _a.error,
          pluginSetupResult = _a.pluginSetupResult,
          certificatesProvider = _a.certificatesProvider,
          certificatesProcessor = _a.certificatesProcessor;

      if (!certificatesProvider) {
        if (pluginSetupResult) {
          _this.printError(error);
        }

        return;
      } // Выводим информацию о сертификатах


      var items = certificatesProvider.getAllItems();

      if (items.length === 0) {
        _this.addLine("\u0412 \u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0430\u0445 \u043D\u0435\u0442 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044B\u0445 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0432");
      }

      var validItems = certificatesProcessor.getValidItems(items);
      var revokedItems = certificatesProcessor.getRevokedItems(items);
      var cabucIssuersItems = certificatesProcessor.getCabucIssersItems(validItems);
      var activeItems = certificatesProcessor.getActiveItems(validItems);
      var expiringItems = certificatesProcessor.getExpiringItems(validItems);
      var expiredItems = certificatesProcessor.getExpiredItems(validItems);
      var invalidIssuersItems = certificatesProcessor.getInvalidIssuerItems(items);
      var filteredByClientItems = certificatesProcessor.getFilteredByClient(items);

      _this.addLine("\u0412\u0441\u0435\u0433\u043E \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043E \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0432: " + items.length);

      _this.tabLevel++;

      _this.addLine("\u0421\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u044B \u043E\u0442 \u0432\u0430\u043B\u0438\u0434\u043D\u044B\u0445 \u0438\u0437\u0434\u0430\u0442\u0435\u043B\u0435\u0439: " + validItems.length);

      _this.addLine("\u0421\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u044B \u0432\u044B\u043F\u0443\u0449\u0435\u043D\u043D\u044B\u0435 \u0432 \u041A\u0410\u0411\u0423\u0426: " + cabucIssuersItems.length);

      _this.addLine("\u0414\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0435 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u044B: " + activeItems.length);

      _this.addLine("\u0418\u0441\u0442\u0435\u043A\u0430\u044E\u0449\u0438\u0435 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u044B: " + expiringItems.length);

      _this.addLine("\u0418\u0441\u0442\u0451\u043A\u0449\u0438\u0435 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u044B: " + expiredItems.length);

      _this.addLine("\u041E\u0442\u043E\u0437\u0432\u0430\u043D\u043D\u044B\u0435 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u044B: " + revokedItems.length);

      _this.tabLevel--;

      _this.printCurrentText(); // Выводим информацию о скрытых сертификатах.


      var hiddenExpiredItems = expiredItems.filter(function (item) {
        return item.visible === false;
      });

      _this.printCertificatesInfos(hiddenExpiredItems, {
        title: 'Скрытые истёкшие сертификаты',
        printHidingReason: true
      });

      var hiddenRevokedItems = revokedItems.filter(function (item) {
        return item.visible === false;
      });

      _this.printCertificatesInfos(hiddenRevokedItems, {
        title: 'Скрытые отозванные сертификаты'
      });

      var hiddenInvalidIssuersItems = invalidIssuersItems;

      _this.printCertificatesInfos(hiddenInvalidIssuersItems, {
        title: 'Скрытые сертификаты от невалидных издателей'
      });

      _this.printCertificatesInfos(filteredByClientItems, {
        title: 'Скрытые сертификаты, отфильтрованные по кастомному фильтру'
      });
    };

    this.printCertificatesInfos = function (items, _a) {
      var printHidingReason = _a.printHidingReason,
          title = _a.title;

      _this.addLine(title + ": " + items.length);

      _this.tabLevel++;

      if (items.length) {
        items.forEach(function (item, index) {
          var certificate = item.certificate;

          _this.addLine(index + 1 + ".\u041E\u0442\u043F\u0435\u0447\u0430\u0442\u043E\u043A \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u0430: " + certificate.thumbprint());

          _this.tabLevel++;

          _this.addLine("\u0412\u043B\u0430\u0434\u0435\u043B\u0435\u0446: " + certificate.owner() + ", \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F: " + certificate.organizationName());

          var inn = certificate.inn() ? "\u0418\u041D\u041D: " + certificate.inn() : '';
          var kpp = certificate.kpp() ? "\u041A\u041F\u041F: " + certificate.kpp() : '';
          var innKpp = [inn, kpp].filter(Boolean).join(', ');

          if (innKpp) {
            _this.addLine("" + innKpp);
          }

          if (printHidingReason) {
            _this.printHidingReason(item);
          }

          _this.tabLevel--;

          _this.printCurrentText();
        });
      }

      _this.tabLevel--;
    };

    this.printHidingReason = function (_a) {
      var certificate = _a.certificate,
          statusInfo = _a.statusInfo;
      _this.tabLevel++;
      var certificatesProcessor = _this.options.certificatesProcessor;

      _this.addLine("\u041F\u0440\u0438\u0447\u0438\u043D\u0430 \u0441\u043A\u0440\u044B\u0442\u0438\u044F:");

      var period = dayjs_1.default(new Date()).diff(certificate.validTo(), 'day');
      var periodStr = _this.formatDayStr(period) + " \u043D\u0430\u0437\u0430\u0434";
      _this.tabLevel++;

      _this.addLine("\u0421\u0440\u043E\u043A \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u0430 \u0437\u0430\u043A\u043E\u043D\u0447\u0438\u043B\u0441\u044F: " + dayjs_1.default(certificate.validTo()).format('DD.MM.YYYY') + " - " + periodStr);

      if (statusInfo) {
        _this.addLine("\u0421\u0442\u0430\u0442\u0443\u0441 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u0430: " + shared_1.CabucStatusCode[statusInfo.status] + ". \u041A\u043E\u0434: " + statusInfo.status);

        var statusPeriod = certificatesProcessor.getPeriodByStatus(statusInfo.status) || 0;

        _this.addLine("\u0421\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442 \u0441\u043E \u0441\u0442\u0430\u0442\u0443\u0441\u043E\u043C " + shared_1.CabucStatusCode[statusInfo.status] + " \u043F\u043E\u043A\u0430\u0437\u044B\u0432\u0430\u0435\u0442\u0441\u044F: " + _this.formatDayStr(statusPeriod));
      }

      _this.tabLevel--;
      _this.tabLevel--;
    };
  }

  return CertificatesListStats;
}();

exports.CertificatesListStats = CertificatesListStats;